import React from "react";
import Header4 from "./../Common/Header4";
import Footer2 from "./../Common/Footer2";
import Banner from "./../Elements/Banner";
import ContactUsForm from "../Elements/ContactUsForm";

let bnrimg = require("./../../images/page_banners/Banner1.JPEG");
let bgimg1 = require("./../../images/background/bg-image.png");

const ContactUs = () => {
  return (
    <>
      <Header4 />
      <div className="page-content">
        <Banner title="Get In Touch" pagename="Contact us" bgimage={bnrimg} />
        {/* SECTION CONTENTG START */}
        <div
          className="section-full p-tb80 inner-page-padding"
          style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          {/* LOCATION BLOCK*/}
          <div className="container">
            {/* GOOGLE MAP & CONTACT FORM */}
            <div className="section-content">
              {/* CONTACT FORM*/}
              <div className="row">
                <div className="col-lg-8 col-md-12 col-sm-12">
                  <ContactUsForm />
                </div>
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <div
                    className="contact-info block-shadow bg-white bg-center p-a40"
                    style={{
                      backgroundImage: "url(images/background/bg-map.png)",
                    }}
                  >
                    <div>
                      {/* TITLE START */}
                      <div className="section-head">
                        <div className="sx-separator-outer separator-left">
                          <div
                            className="sx-separator  bg-moving bg-repeat-x"
                            style={{ backgroundColor: "#22333B" }}
                          >
                            <h3 className="sep-line-one">Info</h3>
                          </div>
                        </div>
                      </div>
                      {/* TITLE END */}
                      <div className="sx-icon-box-wraper left p-b30">
                        <div className="icon-xs">
                          <i className="fa fa-envelope" />
                        </div>
                        <div className="icon-content">
                          <h5 className="m-t0">Email address</h5>
                          <p>info@sunlightcreationz.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION CONTENT END */}
      </div>

      <Footer2 />
    </>
  );
};

export default ContactUs;
